let projects = [
  {
    id: 1,
    name: "Magic Match",
    img: ['/img/magic-match/1.jpeg', '/img/magic-match/2.jpeg', '/img/magic-match/3.jpeg', '/img/magic-match/4.jpeg'],
    description: "A memory game built in HTML, JavaScript, CSS, Bootstrap and React!",
    category: "react",
    thumb: '/img/thumbs/magic-match.jpeg'
  },
  {
    id: 2,
    name: "Portfolio",
    img: ['/img/portfolio/1.jpeg'],
    description: "A portfolio website as an example of website in Vue.js.",
    category: "vue",
    thumb: '/img/thumbs/portfolio.jpeg'
  },
  {
    id: 3,
    name: "MusicShare",
    img: ['/img/musicshare/1.jpeg'],
    description: "A place to share your music with others in just seconds. It was built using HTML, CSS and Bootstrap",
    category: "native",
    thumb: '/img/thumbs/music-share.jpeg'
  },
  {
    id: 4,
    name: "Ekonomsko-turisticka Skola",
    img: ['/img/school/1.jpeg'],
    description: "Educational website built with HTML, CSS, Bootstrap, and JS",
    category: "native",
    thumb: '/img/thumbs/school.jpeg'
  },
  {
    id: 5,
    name: "BabySi",
    img: ['/img/babysi/1.jpeg', '/img/babysi/2.jpeg', '/img/babysi/3.jpeg'],
    description: "Find babysitters around you in just seconds! Built for Android",
    category: "android",
    thumb: '/img/thumbs/baby-si.jpeg'
  },
  {
    id: 6,
    name: "Guessing Game",
    img: ['/img/guess/1.jpeg'],
    description: "Fun guessing game made for Android",
    category: "android",
    thumb: '/img/thumbs/guess-word.jpeg'
  },
  {
    id: 7,
    name: "MyDentSched",
    img: ['/img/dent/1.jpeg', '/img/dent/2.jpeg'],
    description: "Perfect place to keep all your notes about your patients as a dentist!",
    category: "android",
    thumb: '/img/thumbs/dent-sched.jpeg'
  },
  {
    id: 8,
    name: "Nasa News",
    img: ['/img/nasanews/1.jpeg', '/img/nasanews/2.jpeg', '/img/nasanews/3.jpeg', '/img/nasanews/4.jpeg'],
    description: "All news from NASA right on your phone, with push notifications and Astronomy Picture of the Day!",
    category: "android",
    thumb: '/img/thumbs/nasa-news.jpeg'
  },
  {
    id: 9,
    name: "Nature Gallery",
    img: ['/img/nature/1.jpeg', '/img/nature/2.jpeg', '/img/nature/3.jpeg', "/img/nature/4.jpeg", '/img/nature/5.jpeg'],
    description: "Share all your photos on our famous platform!",
    category: "android",
    thumb: '/img/thumbs/nature-gallery.jpeg'
  },
  {
    id: 10,
    name: "Tonight's Movie",
    img: ['/img/tonights/1.jpeg', '/img/tonights/2.jpeg', '/img/tonights/3.jpeg'],
    description: "Perfect for the people who love watching movies, but don't know what to watch",
    category: "android",
    thumb: '/img/thumbs/tonights.jpeg'
  },
  {
    id: 11,
    name: "Online Karma Shop",
    img: ['/img/shop/1.jpeg'],
    description: "Online store",
    category: "native",
    thumb: '/img/thumbs/shop.jpeg'
  },
  {
    id: 12,
    name: "My Money",
    img: ['/img/my-money/1.jpeg', '/img/my-money/2.jpeg'],
    description: "Keep track of your spending in an elegant and easy way!",
    category: "react",
    thumb: '/img/thumbs/my-money.jpeg'
  },
  {
    id: 13,
    name: "Vulcan RPS",
    img: ['/img/vulcanrps/1.jpeg', '/img/vulcanrps/2.jpeg', '/img/vulcanrps/3.jpeg'],
    description: "InGame store for Vulcan RPS with PayPal payment integration",
    category: "react",
    thumb: '/img/thumbs/vulcanrps.jpeg'
  }

//  Add more


]

const buttons = [
  {
    name: "All",
    value: "all"
  },
  {
    name: "Android",
    value: "android"
  },
  {
    name: "Native",
    value: "native"
  },
  {
    name: "React",
    value: "react"
  },
  {
    name: "Vue",
    value: "vue"
  }
]

export {projects, buttons};

